import styled, { css } from 'styled-components'

export const Column = styled.div<{
	$minWidthPx?: number
}>`
	display: flex;
	flex-direction: column;
	margin-top: 0;
	gap: 16px;

	${(p) =>
		p.$minWidthPx &&
		css`
			min-width: min(${p.$minWidthPx}px, 100%);
		`}
`
